import { v4 as uuidv4 } from 'uuid';
/**
 * The records one deletion produces.
 *
 * Both are minted here rather than by the caller, because the pair is the
 * thing that must not drift: a pending change without a tombstone syncs the
 * deletion once and lets it come back, and a tombstone without a pending
 * change is a deletion the engine never gets told about.
 */
export function deletionEffect(entityType, ids, now = new Date().toISOString()) {
    const list = [...ids];
    return {
        tombstones: list.map((entityId) => ({
            id: uuidv4(), entityType, entityId, deletedAt: now,
        })),
        pendingChanges: list.map((entityId) => ({
            id: uuidv4(), type: entityType, operation: 'delete', entityId, timestamp: now,
        })),
    };
}
/**
 * Apply those records to a snapshot — the server's half.
 *
 * The app hands each record to Dexie; the MCP server has no database, only the
 * `ExportData` it loaded and will push back, so it appends them here. Typed
 * loosely on purpose: `ExportData` lives in @trackmind/storage, which depends
 * on core, so naming it would invert the dependency.
 *
 * Deliberately skips an id that already has a tombstone. Harmless if it did
 * not — the engine reads a set — but tombstones are kept for weeks and there
 * is no reason to grow the file with duplicates.
 */
export function appendDeletionRecords(snapshot, records) {
    if (records.tombstones.length === 0)
        return 0;
    // A snapshot written before the tombstones file existed has none, and a
    // brand-new account has none either. Both are normal; neither should throw.
    const existing = snapshot.tombstones ?? { tombstones: [] };
    const already = new Set(existing.tombstones.map((t) => `${t.entityType}:${t.entityId}`));
    const added = records.tombstones.filter((t) => !already.has(`${t.entityType}:${t.entityId}`));
    snapshot.tombstones = { ...existing, tombstones: [...existing.tombstones, ...added] };
    return added.length;
}
//# sourceMappingURL=deletion-effect.js.map